<!-- Poll Section -->
<div class="mt-3" *ngIf="poll">
  <div class="poll-container rounded-xl overflow-hidden">
    <!-- Poll Header -->
    <div class="poll-header px-4 py-3 flex items-center gap-2">
      <div class="poll-icon-wrapper">
        <i class="fas fa-chart-bar text-white text-xs"></i>
      </div>
      <h4 class="font-semibold text-gray-800 text-sm leading-tight flex-1">{{ poll.question }}</h4>
      <span
        *ngIf="poll.is_multiple_choice"
        class="text-[10px] font-medium text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full whitespace-nowrap"
      >
        Múltiple
      </span>
    </div>

    <!-- Options -->
    <div class="px-4 pb-2 space-y-1.5">
      <div
        *ngFor="let option of poll.options; let i = index"
        class="poll-option relative rounded-lg overflow-hidden transition-all duration-200"
        [ngClass]="{
          'poll-option--voted': option.user_voted,
          'poll-option--winner': (poll.user_voted || !poll.is_active) && isWinningOption(option),
          'poll-option--clickable': !poll.user_voted && poll.is_active,
          'poll-option--revealed': poll.user_voted || !poll.is_active,
        }"
        (click)="onOptionClick(option)"
      >
        <!-- Background Progress Bar (shown after voting) -->
        <div
          *ngIf="poll.user_voted || !poll.is_active"
          class="poll-option__bar absolute inset-0 transition-all duration-500 ease-out"
          [ngClass]="{
            'poll-option__bar--user': option.user_voted,
            'poll-option__bar--winner': isWinningOption(option) && !option.user_voted,
          }"
          [style.width.%]="getOptionPercentage(option)"
        ></div>

        <!-- Option Content -->
        <div class="relative z-10 flex items-center px-3 py-2.5">
          <!-- Indicator -->
          <div class="poll-indicator mr-2.5 flex-shrink-0">
            <div
              *ngIf="!poll.is_multiple_choice"
              class="w-[18px] h-[18px] rounded-full border-2 flex items-center justify-center transition-all duration-200"
              [ngClass]="{
                'border-blue-500 bg-blue-500': option.user_voted,
                'border-gray-300': !option.user_voted,
              }"
            >
              <div *ngIf="option.user_voted" class="w-[7px] h-[7px] bg-white rounded-full"></div>
            </div>
            <div
              *ngIf="poll.is_multiple_choice"
              class="w-[18px] h-[18px] rounded-[4px] border-2 flex items-center justify-center transition-all duration-200"
              [ngClass]="{
                'border-blue-500 bg-blue-500': option.user_voted,
                'border-gray-300': !option.user_voted,
              }"
            >
              <i *ngIf="option.user_voted" class="fas fa-check text-white text-[9px]"></i>
            </div>
          </div>

          <!-- Option Text -->
          <span
            class="text-[13px] flex-1 leading-snug transition-all duration-200"
            [ngClass]="{
              'font-semibold text-gray-900': option.user_voted,
              'font-medium text-gray-700': !option.user_voted,
            }"
          >
            {{ option.text }}
          </span>

          <!-- Results (after voting) -->
          <div
            *ngIf="poll.user_voted || !poll.is_active"
            class="flex items-center gap-1.5 ml-3 flex-shrink-0"
          >
            <span
              class="text-[13px] font-bold tabular-nums"
              [ngClass]="{
                'text-blue-600': option.user_voted,
                'text-gray-700': !option.user_voted,
              }"
            >
              {{ getOptionPercentage(option) }}%
            </span>
            <span class="text-[11px] text-gray-400 tabular-nums">({{ option.votes_count }})</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Poll Footer -->
    <div class="poll-footer px-4 py-2.5 flex items-center justify-between">
      <div class="flex items-center gap-3 text-[11px] text-gray-400">
        <span class="flex items-center gap-1">
          <i class="fas fa-users text-[10px]"></i>
          {{ poll.total_votes }} {{ poll.total_votes === 1 ? 'voto' : 'votos' }}
        </span>
        <span *ngIf="poll.expires_at" class="flex items-center gap-1">
          <i class="fas fa-clock text-[10px]"></i>
          {{ getTimeUntilExpiry() }}
        </span>
        <span *ngIf="poll.is_anonymous" class="flex items-center gap-1">
          <i class="fas fa-user-secret text-[10px]"></i>
          Anónima
        </span>
      </div>

      <span
        *ngIf="!poll.is_active"
        class="text-[11px] font-semibold text-red-400 flex items-center gap-1"
      >
        <i class="fas fa-lock text-[9px]"></i>
        Cerrada
      </span>
    </div>
  </div>
</div>
